<template>
  <div class="flex flex-col gap-2">
    <label class="text-sm text-gray-700">{{ $t("users.create_user.title_user_type") }}</label>
    <Select
      :model-value="userType"
      :options="userTypeOptions"
      optionLabel="title"
      optionValue="value"
      optionDisabled="disabled"
      class="w-full text-sm"
      @update:model-value="$emit('update:userType', $event)"
    >
      <template #option="slotProps">
        <div>
          {{ slotProps.option.title }}
          <span v-if="slotProps.option.disabled && slotProps.option.showLimitMessage" class="text-red-500 text-xs ml-2">
            ({{ $t("users.create_user.type_limit_reached") }})
          </span>
        </div>
      </template>
    </Select>
  </div>
</template>

<script>
import { Select } from 'primevue';

export default {
  name: 'UserTypeSelectionSection',
  components: {
    Select,
  },
  props: {
    userType: {
      type: Number,
      required: true,
    },
    limits: {
      type: Object,
      required: true,
    },
    enableAdminType: {
      type: Boolean,
      required: true,
    },
  },
  emits: ['update:userType'],
  computed: {
    userTypeOptions() {
      return [
        {
          title: this.$t("users.user_type_agent"),
          value: 1,
          disabled: this.limits.noAgent || this.limits.isAgentLimit,
          showLimitMessage: this.limits.noAgent || this.limits.isAgentLimit,
        },
        {
          title: this.$t("users.user_type_supervisor"),
          value: 2,
          disabled: this.limits.noReporter || this.limits.isReporterLimit,
          showLimitMessage: this.limits.noReporter || this.limits.isReporterLimit,
        },
        {
          title: this.$t("users.user_type_admin"),
          value: 3,
          disabled: !this.enableAdminType || this.limits.noAdmin || this.limits.isAdminLimit,
          showLimitMessage: !this.enableAdminType || this.limits.noAdmin || this.limits.isAdminLimit,
        },
        {
          title: this.$t("users.user_type_wallboard"),
          value: 5,
          disabled: false,
          showLimitMessage: false,
        },
      ];
    },
  },
};
</script> 